export const menuItems = [
    {
        id: 1,
        label: "Početna",
        icon: "esei icon-home esei-default",
        badge: {
            variant: "info",
            text: "menuitems.dashboard.badge"
        },
        link: "/",
        isTitle: false,
        menu : false,
        logout: false,
        link2:''
    },
    {
        id: 2,
        label: "Glavni meni",
        isTitle: true,
        menu : false,
        logout: false,
        link2:''

    },
    
    {
        id: 3,
        label: "CMS",
        icon: "esei icon-grip-solid esei-lg",
        badge: {
            variant: "info",
            text: "menuitems.dashboard.badge"
        },
        link: "/cms/menu",
        link2:'',
        isTitle: false,
        menu : false,
        logout: false

    },
    {
        id: 4,
        label: "Komponente",
        link2:'',
        isTitle: true,
        menu : false,
        logout: false
    },
    {
        id: 5,
        label: "Vesti",
        icon: "esei icon-file esei-default",
        link: "/cms/news",
        link2:'/cms/news/news-view',
        isTitle: false,
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Dodavanje kategorija",
                link: "/cms/news/news-category-add",
                parentId: 5

            },
             {
                id: 2,
                label: "Pregled kategorija",
                link: "/cms/news/news-category-view",
                parentId: 5

            },
            {
                id: 3,
                label: "Dodavanje vesti",
                link: "/cms/news/news-add",
                parentId: 5

            },
            {
                id: 4,
                label: "Pregled vesti",
                link: "/cms/news/news-view",
                parentId: 5
                
            },
            {
                id: 5,
                label: "Keš vesti",
                link: "/cms/news/news-cache",
                parentId: 5
                
            },
        ]
    },
    {
        id: 6,
        label: "Baza",
        icon: "esei icon-database esei-default",
        link: "/cms/base",
        link2:'/cms/base',
        isTitle: false,
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Ažuriranje cena",
                link: "/cms/base",
                parentId: 6
            },
            {
                id: 2,
                label: "Keširanje nedelja",
                link: "/cms/base/cache-week",
                parentId: 6
            },
            {
                id: 3,
                label: "Keširanje trenutne nedelje",
                link: "/cms/base/cache-current-week",
                parentId: 6
            },
            {
                id: 4,
                label: "Keširanje kursa",
                link: "/cms/base/cache-exchange",
                parentId: 6
            },
            {
                id: 5,
                label: "Kategorije",
                link: "/cms/base/stips/category/stips-category-add",
                parentId: 6
            },
             {
                id: 6,
                label: "Kategorije pregled",
                link: "/cms/base/stips/category/stips-category-view",
                parentId: 6
            },
            {
                id: 7,
                label: "Izvor",
                link: "/cms/base/stips/source/stips-source-add",
                parentId: 6
            },
             {
                id: 8,
                label: "Izvor pregled",
                link: "/cms/base/stips/source/stips-source-view",
                parentId: 6
            },
             {
                id: 9,
                label: "Nedelje dodavanje",
                link: "/cms/base/stips/week/stips-week-add",
                parentId: 6
            },
             {
                id: 10,
                label: "Nedelje pregled",
                link: "/cms/base/stips/week/stips-week-view",
                parentId: 6
            },
            {
                id: 10,
                label: "Nedelje keširanje",
                link: "/cms/base/stips/week/stips-week-cache",
                parentId: 6
            },
             {
                id: 11,
                label: "Pesticidi Fungicidi",
                link: "/cms/base/pesticidi/fungicidi",
                parentId: 10
            },
            {
                id: 12,
                label: "Pesticidi Herbicidi",
                link: "/cms/base/pesticidi/herbicidi",
                parentId: 10
            },
            {
                id: 13,
                label: "Pesticidi Insekticidi",
                link: "/cms/base/pesticidi/insekticidi",
                parentId: 10
            },
            {
                id: 14,
                label: "Krvatska Kvantaš",
                link: "/cms/base/hrvatska/kvantas",
                parentId: 10
            },
            {
                id: 15,
                label: "Krvatska Zelena",
                link: "/cms/base/hrvatska/zelena",
                parentId: 10
            },
            {
                id: 16,
                label: "Žitarice berza",
                link: "/cms/base/berza/zitarice",
                parentId: 10
            },
            {
                id: 17,
                label: "BIH Biljeljina",
                link: "/cms/base/bih/biljeljina",
                parentId: 10
            },
            {
                id: 18,
                label: "BIH Banjaluka",
                link: "/cms/base/bih/banjaluka",
                parentId: 10
            },
             {
                id: 19,
                label: "Semena i Đubriva - Semena",
                link: "/cms/base/seeds/seeds",
                parentId: 10
            },
            {
                id: 20,
                label: "Semena i Đubriva - Đubriva",
                link: "/cms/base/seeds/fertilizers",
                parentId: 10
            },
            {
                id: 21,
                label: "Crna Gora",
                link: "/cms/base/montenegro/montenegro",
                parentId: 10
            },
             {
                id: 22,
                label: "EU klanica",
                link: "/cms/base/klanica/eu-klanica",
                parentId: 10
            },
             {
                id: 23,
                label: "Retail",
                link: "/cms/base/retail/retail-add",
                parentId: 10
            },
             {
                id: 24,
                label: "Retail pregled",
                link: "/cms/base/retail/retail-view",
                parentId: 10
            },
        ]
    },
    {
        id: 7,
        label: "Admin",
        icon: "esei icon-user-gear-solid esei-default",
        link: "/cms/admins/",
        link2:'/cms/admins/users-views',
        isTitle: false,
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Uloge",
                link: "/cms/admins/role",
                parentId: 7
            },
            {
                id: 2,
                label: "Pregled uloga",
                link: "/cms/admins/role-views",
                parentId: 7
            },
            {
                id: 3,
                label: "Dodavanje admina",
                link: "/cms/admins/users",
                parentId: 7
            },
            {
                id: 4,
                label: "Pregled admina",
                link: "/cms/admins/users-views",
                parentId: 7
            },
           
           
        ]

    },
    {
        id: 8,
        label: "Događaji",
        icon: "esei icon-calendar-solid esei-default",
        isTitle: false,
        link2:'/cms/event/event-views',
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Kategorije dodavanje",
                link: "/cms/event/category-add",
                parentId: 8
            },
            {
                id: 2,
                label: "Kategorije pregled",
                link: "/cms/event/category-view",
                parentId: 8
            },
            {
                id: 3,
                label: "Dodavanje mesta",
                link: "/cms/event/place-add",
                parentId: 8
            },
            {
                id: 4,
                label: "Pregled mesta",
                link: "/cms/event/place-views",
                parentId: 8
            },
            {
                id: 5,
                label: "Dodavanje događaja",
                link: "/cms/event/event-add",
                parentId: 8
            },
            {
                id: 6,
                label: "Pregled događaja",
                link: "/cms/event/event-views",
                parentId: 8
            },
            {
                id: 7,
                label: "Keš događaja",
                link: "/cms/event/event-cache",
                parentId: 8
            },
            {
                id: 8,
                label: "Keš kategorije događaja",
                link: "/cms/event/event-cache-category",
                parentId: 8
            },
            {
                id: 8,
                label: "Keš KadaJe",
                link: "/cms/event/event-cache-when",
                parentId: 8
            },
            {
                id: 9,
                label: "Keš kategorije KadaJe",
                link: "/cms/event/event-cache-category-when",
                parentId: 89
            },
        ]
    },
    {
        id: 9,
        label: "Video",
        icon: "esei icon-video-camera esei-default",
        isTitle: false,
        link2:'/cms/video/video-views',
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Dodavanje",
                link: "/cms/video/video-add",
                parentId: 9
            },
            {
                id: 2,
                label: "Pregled",
                link: "/cms/video/video-views",
                parentId: 9
            },
           
           
        ]
    },
    {
        id: 10,
        label: "Oglasi",
        icon: "esei icon-bullhorn esei-default",
        isTitle: false,
        link2:'/cms/customer/customer-items',
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Pregled oglasa",
                link: "/cms/customer/customer-items",
                parentId: 10
            },
            {
                id: 2,
                label: "Pregled korisnika",
                link: "/cms/customer/customer-views",
                parentId: 10
            },
            {
                id: 3,
                label: "Dodavanje kategorija",
                link: "/cms/customer/category-add",
                parentId: 10
            },
            {
                id: 4,
                label: "Pregled kategorija",
                link: "/cms/customer/category-views",
                parentId: 10
            },
            {
                id: 5,
                label: "Dodavanje potkategorija",
                link: "/cms/customer/subcategory-add",
                parentId: 10
            },
            {
                id: 6,
                label: "Pregled potkategorija",
                link: "/cms/customer/subcategory-views",
                parentId: 10
            },
            {
                id: 7,
                label: "Dodavanje mesta",
                link: "/cms/customer/district-add",
                parentId: 10
            },
            {
                id: 8,
                label: "Pregled mesta",
                link: "/cms/customer/district-views",
                parentId: 10
            },
            {
                id: 9,
                label: "Obnavljanje keša",
                link: "/cms/customer/category-cache",
                parentId: 10
            },
            {
                id: 10,
                label: "Obnavljanje keša mesta",
                link: "/cms/customer/district-cache",
                parentId: 10
            },
            {
                id: 11,
                label: "Keš oglasa",
                link: "/cms/customer/items-cache",
                parentId: 10
            },
            {
                id: 12,
                label: "Pregled loga",
                link: "/cms/customer/log-views",
                parentId: 10
            },
            {
                id: 13,
                label: "Dodavanje države",
                link: "/cms/customer/state-add",
                parentId: 10
            },
            {
                id: 14,
                label: "Pregled države",
                link: "/cms/customer/state-view",
                parentId: 10
            },
            {
                id: 15,
                label: "Ažuriranje pregleda i praćenja",
                link: "/cms/customer/view-follower-count",
                parentId: 10
            },
        ]
    },
    {
        id: 11,
        label: "Adresar",
        icon: "esei icon-address-book esei-default",
        isTitle: false,
        link2:'/cms/address/address-book-views',
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Dodavenje kategorije",
                link: "/cms/address/address-category-add",
                parentId: 11
            },
            {
                id: 2,
                label: "Pregeld kategorije",
                link: "/cms/address/address-category-views",
                parentId: 11
            },
            {
                id: 3,
                label: "Dodavanje adresara",
                link: "/cms/address/address-book-add",
                parentId: 11
            },
            {
                id: 4,
                label: "Pregled adresara",
                link: "/cms/address/address-book-views",
                parentId: 11
            },
        ]
    },
    {
        id: 12,
        label: "Anketa",
        icon: "esei icon-square-poll-horizontal-solid esei-defauld",
        isTitle: false,
        link2:'/cms/survey/survey-category-views',
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Dodavenje ankete",
                link: "/cms/survey/survey-category-add",
                parentId: 12
            },
            {
                id: 2,
                label: "Pregled ankete",
                link: "/cms/survey/survey-category-views",
                parentId: 12
            },
            
        ]
    },
    {
        id: 13,
        label: "Stranice",
        icon: "esei icon-file esei-default",
        link: "/cms/page/page",
        link2:'/cms/page/page',
        isTitle: false,
        menu : true,
        logout: false,
        
    },
    {
        id: 14,
        label: "Brisanje slika",
        icon: "esei icon-eraser esei-defauld",
        link: "/cms/img-del/img-del",
        link2:'/cms/img-del/img-del',
        isTitle: false,
        menu : true,
        logout: false,


        
    },
    {
        id: 15,
        label: "Cene",
        icon: "esei icon-area-chart esei-defauld",
        isTitle: false,
        link2:'/cms/price/price-views',
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Dodavanje kategorija",
                link: "/cms/price-category/price-category-add",
                parentId: 15
            },
            {
                id: 2,
                label: "Pregled kategoria",
                link: "/cms/price-category/price-category-views",
                parentId: 15
            },
            {
                id: 3,
                label: "Dodavanje potkategorija",
                link: "/cms/price-subcategory/price-subcategory-add",
                parentId: 15
            },
            {
                id: 4,
                label: "Pregled potkategorija",
                link: "/cms/price-subcategory/price-subcategory-views",
                parentId: 15
            },
            {
                id: 5,
                label: "Dodavanje cena",
                link: "/cms/price/price-add",
                parentId: 15
            },
            {
                id: 6,
                label: "Pregled cena",
                link: "/cms/price/price-views",
                parentId: 15
            },
            {
                id: 7,
                label: "Keširanje kategorija",
                link: "/cms/price-category/category-cache",
                parentId: 15
            },
            {
                id: 8,
                label: "Keširanje kategorija Koliko Košta",
                link: "/cms/price-category/how-mach-category-cache",
                parentId: 15
            },
            {
                id: 9,
                label: "Dodavanje pijace | marketa | prodavnice",
                link: "/cms/price-type/price-type-add",
                parentId: 15
            },
            {
                id: 10,
                label: "Pregled pijace | marketa | prodavnice",
                link: "/cms/price-type/price-type-views",
                parentId: 15
            },
        ]
    },
    {
        id: 16,
        label: "Sitemap",
        icon: "esei icon-sitemap esei-default",
        isTitle: false,
        link2:'/cms/sitemap/sitemap-create',
        menu : true,
        logout: false,
        subItems:[
            {
                id: 1,
                label: "Kreiranje sitemap PIJACE",
                link: "/cms/sitemap/sitemap-create",
                parentId: 16
            },
             {
                id: 1,
                label: "Kreiranje sitemap KADAJE",
                link: "/cms/sitemap/sitemap-kadaje",
                parentId: 16
            },
        ],
        
    },
    {
        id: 17,
        label: "Recepti",
        icon: "esei icon-cake-candles-solid",
        isTitle: false,
        link2:"/cms/recipe/category/recipe-category-view",
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Dodavanje kategorija",
                link: "/cms/recipe/category/recipe-category-add",
                parentId: 17
            },
            {
                id: 2,
                label: "Pregled kategoria",
                link: "/cms/recipe/category/recipe-category-view",
                parentId: 17
            },
            {
                id: 3,
                label: "Dodavanje recepta",
                link: "/cms/recipe/recipe/recipe-add",
                parentId: 17
            },
            {
                id: 4,
                label: "Pregled recepta",
                link: "/cms/recipe/recipe/recipe-view",
                parentId: 17
            },
            {
                id: 5,
                label: "Keširanje kategorija",
                link: "/cms/recipe/category/recipe-category-cache",
                parentId: 17
            },
            {
                id: 6,
                label: "Keširanje recepata",
                link: "/cms/recipe/recipe/recipe-cache",
                parentId: 17
            },
        ]
    },
     {
        id: 18,
        label: "Šta leči",
        icon: "esei icon-briefcase-medical-solid",
        isTitle: false,
        link2:"/cms/medicine/category/medicine-category-view",
        menu : true,
        logout: false,
        subItems: [
            {
                id: 1,
                label: "Dodavanje kategorija",
                link: "/cms/medicine/category/medicine-category-add",
                parentId: 18
            },
            {
                id: 2,
                label: "Pregled kategoria",
                link: "/cms/medicine/category/medicine-category-view",
                parentId: 18
            },
            {
                id: 3,
                label: "Dodavanje šta leči",
                link: "/cms/medicine/medicine/medicine-add",
                parentId: 18
            },
            {
                id: 4,
                label: "Pregled šta leči",
                link: "/cms/medicine/medicine/medicine-view",
                parentId: 18
            },
            {
                id: 5,
                label: "Keširanje kategorija",
                link: "/cms/medicine/category/medicine-category-cache",
                parentId: 18
            },
            {
                id: 6,
                label: "Keširanje šta leči",
                link: "/cms/medicine/medicine/medicine-cache",
                parentId: 18
            },
        ]
    },
    {
        id: 19,
        label: "Crkveni kalendar",
        icon: "esei icon-church-solid",
        isTitle: false,
        link2:"/cms/church/month/church-month-view",
        menu : true,
        logout: false,
        subItems: [
               {
                id: 11,
                label: "Dodavanje kalendara",
                link: "/cms/church/church/church-add",
                parentId: 19
            },
             {
                id: 12,
                label: "Pregled kalendara",
                link: "/cms/church/church/church-view",
                parentId: 19
            },
            {
                id: 1,
                label: "Dodavanje meseca",
                link: "/cms/church/month/church-month-add",
                
                parentId: 19
            },
            {
                id: 2,
                label: "Pregled meseca",
                link: "/cms/church/month/church-month-view",
                parentId: 19
            },
            {
                id: 3,
                label: "Dodavanje godine",
                link: "/cms/church/year/church-year-add",
                parentId: 19
            },
            {
                id: 4,
                label: "Pregled godine",
                link: "/cms/church/year/church-year-view",
                parentId: 19
            },
             {
                id: 5,
                label: "Dodavanje svetaca",
                link: "/cms/church/saint/church-saint-add",
                parentId: 19
            },
            {
                id: 6,
                label: "Pregled svetaca",
                link: "/cms/church/saint/church-saint-view",
                parentId: 19
            },
             {
                id: 7,
                label: "Dodavanje posta",
                link: "/cms/church/fast/church-fast-add",
                parentId: 19
            },
            {
                id: 8,
                label: "Pregled posta",
                link: "/cms/church/fast/church-fast-view",
                parentId: 19
            },
             {
                id: 9,
                label: "Keširanje",
                link: "/cms/church/year/church-year-cache",
                parentId: 19
            },
        ]
    },
     {
        id: 20,
        label: "Prodavnica",
        icon: "esei icon-bag-shopping-solid",
        isTitle: false,
        link2:"/cms/retailer/retailer/retailer-add",
        menu : true,
        logout: false,
        subItems: [
               {
                id: 1,
                label: "Dodavanje prodavnica",
                link: "/cms/retailer/retailer/retailer-add",
                parentId: 20
            },
             {
                id: 2,
                label: "Pregled prodavnica",
                link: "/cms/retailer/retailer/retailer-view",
                 class: 'fw-bold text-black',
                parentId: 20
            },
            {
                id: 3,
                label: "Dodavanje kategorije NIVO 1",
                link: "/cms/retailer/category/category-add-lv/0",
                parentId: 20
            },
             {
                id: 4,
                label: "Pregled kategorije NIVO 1",
                link: "/cms/retailer/category/category-view-lv/0",
                 class: 'fw-bold text-black',
                parentId: 20
            },
              {
                id: 5,
                label: "Dodavanje kategorije NIVO 2",
                link: "/cms/retailer/category/category-add-lv/1",
                parentId: 20
            },
            {
                id: 6,
                label: "Pregled kategorije NIVO 2",
                link: "/cms/retailer/category/category-view-lv/1",
                 class: 'fw-bold text-black',
                parentId: 20
            },
            {
                id: 7,
                label: "Dodavanje kategorije NIVO 3",
                link: "/cms/retailer/category/category-add-lv/2",
                parentId: 20
            },
            {
                id: 8,
                label: "Pregled kategorije NIVO 3",
                link: "/cms/retailer/category/category-view-lv/2",
                 class: 'fw-bold text-black',
                parentId: 20
            },
             {
                id: 9,
                label: "Dodavanje brenda",
                link: "/cms/retailer/brand/brand-add",
                parentId: 20
            },
            {
                id: 10,
                label: "Pregled brenda",
                link: "/cms/retailer/brand/brand-view",
                 class: 'fw-bold text-black',
                parentId: 20
            },
            {
                id: 11,
                label: "Keširanje brenda",
                link: "/cms/retailer/brand/brand-cache",
                parentId: 20
            },
            {
                id: 12,
                label: "Pregled SKRAPOVANIH proizvoda",
                link: "/cms/retailer/product/scraper-product-view",
                parentId: 20
            },
            {
                id: 13,
                label: "Pregled proizvoda",
                link: "/cms/retailer/product/retailer-product-view", 
                parentId: 20
            },
            {
                id: 14,
                label: "Pregled MASTER proizvoda",
                link: "/cms/retailer/product/master-product-view",   
                parentId: 20
            },
             {
                id: 15,
                label: "Skrapovanje podataka",
                link: "/cms/retailer/scraper/scraper-data",
                parentId: 20
            },
        ]
    },{
        id: 21,
        label: "Kategorije za sajt",
        icon: "esei icon-wrench-solid",
        isTitle: false,
        link2:"/cms/retailer/retailer/retailer-add",
        menu : true,
        logout: false,
        subItems: [
               {
                id: 1,
                label: "Dodavanje kategorije NIVO 1",
                link: "/cms/retailer/catalog/catalog-add-lv/0",
                parentId: 21
            },
            {
                id: 2,
                label: "Pregled kategorije NIVO 1",
                link: "/cms/retailer/catalog/catalog-view-lv/0",
                class: 'fw-bold text-black',
                parentId: 21
            },
            {
                id: 3,
                label: "Dodavanje kategorije NIVO 2",
                link: "/cms/retailer/catalog/catalog-add-lv/1",
                parentId: 21
            },
             {
                id: 3,
                label: "Pregled kategorije NIVO 2",
                link: "/cms/retailer/catalog/catalog-view-lv/1",
                class: 'fw-bold text-black',
                parentId: 21
            },
            {
                id: 4,
                label: "Dodavanje kategorije NIVO 3",
                link: "/cms/retailer/catalog/catalog-add-lv/2",
                parentId: 21
            },
             {
                id: 5,
                label: "Pregled kategorije NIVO 3",
                link: "/cms/retailer/catalog/catalog-view-lv/2",
                class: 'fw-bold text-black',
                parentId: 21
            },
            {
                id: 6,
                label: "Mapiranje kategorija",
                link: "/cms/retailer/map/map-add",
                parentId: 21
            },
            {
                id: 7,
                label: "Pregled mapiranja kategorija",
                link: "/cms/retailer/map/map-view",
                 class: 'fw-bold text-black',
                parentId: 21
            },
           
        ]
        },
    {
        id: 22,
        label: "Logout",
        icon: "esei icon-chevron-circle-left font-size-16",
        link: "",
        link2:'',
        isTitle: false,
        menu : false,
        logout: true
        
    },

    
]

